import { differenceInDays, startOfDay } from 'date-fns'

export const getLengthOfStay = ({
  checkIn,
  checkOut,
}: {
  checkIn: string | Date
  checkOut: string | Date
}) => {
  const nights = differenceInDays(
    startOfDay(new Date(checkOut)),
    startOfDay(new Date(checkIn))
  )
  const days = nights + 1
  return {
    days,
    nights,
  }
}
